// Bar Cabrero — schedule and time utilities

// Day index per Date.getDay(): 0=Sun, 1=Mon, ... 6=Sat
export const HOURS = [
  { label: 'Domingo',   ranges: [[11 * 60 + 30, 16 * 60]] },                     // Sun 11:30–16
  { label: 'Lunes',     ranges: [[11 * 60, 16 * 60], [19 * 60, 23 * 60]] },      // Mon
  { label: 'Martes',    ranges: [] },                                            // Tue closed
  { label: 'Miércoles', ranges: [[11 * 60, 16 * 60], [19 * 60, 23 * 60]] },      // Wed
  { label: 'Jueves',    ranges: [[11 * 60, 16 * 60], [19 * 60, 23 * 60]] },      // Thu
  { label: 'Viernes',   ranges: [[11 * 60, 16 * 60], [19 * 60, 24 * 60]] },      // Fri 19–24
  { label: 'Sábado',    ranges: [[11 * 60, 16 * 60], [19 * 60, 24 * 60]] },      // Sat 11–16 · 19–24
];

export const SUNDAY = 0;
export const VERMUT_START_HOUR = 11;
export const VERMUT_START_MIN = 30;
export const VERMUT_END_HOUR = 16;

export function fmtTime(mins) {
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}

/** Returns { open, msg } describing whether the bar is open right now. */
export function getStatus(now = new Date()) {
  const t = now.getHours() * 60 + now.getMinutes();
  const day = HOURS[now.getDay()];

  for (const [s, e] of day.ranges) {
    if (t >= s && t < e) return { open: true, msg: `Hoy abierto · cierra a las ${fmtTime(e)}` };
  }

  const next = day.ranges.find(([s]) => s > t);
  if (next) return { open: false, msg: `Hoy abrimos a las ${fmtTime(next[0])}` };

  for (let i = 1; i <= 7; i++) {
    const d = HOURS[(now.getDay() + i) % 7];
    if (d.ranges.length) {
      const dayName = i === 1 ? 'mañana' : d.label.toLowerCase();
      return { open: false, msg: `Cerrado · ${dayName} abrimos a las ${fmtTime(d.ranges[0][0])}` };
    }
  }

  return { open: false, msg: 'Cerrado' };
}

/** Returns Date of next vermut (Sunday 11:30) OR string 'live' if currently happening. */
export function getNextVermut(now = new Date()) {
  if (now.getDay() === SUNDAY) {
    const start = new Date(now); start.setHours(VERMUT_START_HOUR, VERMUT_START_MIN, 0, 0);
    const end   = new Date(now); end.setHours(VERMUT_END_HOUR, 0, 0, 0);
    if (now < start) return start;
    if (now < end)   return 'live';
  }
  const target = new Date(now);
  const daysToSunday = (7 - now.getDay()) % 7 || 7;
  target.setDate(now.getDate() + daysToSunday);
  target.setHours(VERMUT_START_HOUR, VERMUT_START_MIN, 0, 0);
  return target;
}

/** Difference in d/h/m/s between target Date and now. Returns null if past. */
export function diffParts(target, now = Date.now()) {
  const ms = target.getTime() - now;
  if (ms <= 0) return null;
  return {
    d: Math.floor(ms / 86400000),
    h: Math.floor((ms % 86400000) / 3600000),
    m: Math.floor((ms % 3600000) / 60000),
    s: Math.floor((ms % 60000) / 1000),
  };
}

/** Local YYYY-MM-DD for a Date (avoids UTC drift from toISOString). */
export function toLocalISODate(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** Parse YYYY-MM-DD as a local Date (no timezone surprises). */
export function parseLocalDate(iso) {
  if (!iso) return null;
  const [y, m, d] = iso.split('-').map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
}

/**
 * Pickup time slots (in minutes-of-day) for a given Date,
 * derived from HOURS. We allow pickup from opening to (close - 15min)
 * in 15-minute increments. Returns [] for closed days.
 */
export function getPickupSlots(date, stepMin = 15, lastSlotLeadMin = 15) {
  if (!date) return [];
  const day = HOURS[date.getDay()];
  if (!day || !day.ranges.length) return [];
  const slots = [];
  for (const [start, end] of day.ranges) {
    const lastValid = end - lastSlotLeadMin;
    for (let t = start; t <= lastValid; t += stepMin) slots.push(t);
  }
  return slots;
}

/** Returns the day label for a given Date (using HOURS labels). */
export function dayLabel(date) {
  return HOURS[date.getDay()]?.label || '';
}
